// React
import React, { useContext } from "react";

import { useAuth0 } from "@auth0/auth0-react";

import {
  SuperadminWrapper,
  SuperAdminOrganizationBadge,
  SuperAdminOrganizationBadgeHeader,
  SuperAdminOrganizationBadgeContent,
} from "./SuperTopBar.styled";
import { StateUserContext } from "../../../context/UserContext";
import { Typography } from "../../../components/Typography";
import { Icon, InputFieldWithLink } from "../../../components";
import { StateOrganizationContext } from "../../context/OrganizationContext";
import { Button } from "../../../components/Button";
import { logoutFunction } from "../../../components/LogoutButton";
import { updateRecruiterOrganization } from "../../../api/endpoints/recruiter";
import { DispatchErrorContext } from "../../../context/ErrorContext";

const Superadmin = () => {
  const { logout } = useAuth0();
  const errorDispatch = useContext(DispatchErrorContext);
  const { user } = useContext(StateUserContext);
  const { organization } = useContext(StateOrganizationContext);
  const isProduction = process.env.NODE_ENV === "production";
  const reactAppUrl = process.env.REACT_APP_CP_URL;
  const url = reactAppUrl + "/" + organization.slug + "/";

  let stripeCustomerUrl = "";
  let stripeSubscriptionUrl = "";
  if (isProduction) {
    stripeCustomerUrl =
      "https://dashboard.stripe.com" + "/customers/" + organization.customerId;

    stripeSubscriptionUrl =
      "https://dashboard.stripe.com" +
      "/subscriptions/" +
      organization.subscriptionId;
  } else {
    stripeCustomerUrl =
      "https://dashboard.stripe.com" +
      "/test" +
      "/customers/" +
      organization.customerId;

    stripeSubscriptionUrl =
      "https://dashboard.stripe.com" +
      "/test" +
      "/subscriptions/" +
      organization.subscriptionId;
  }

  if (user?.superOrganizationId === user?.organizationId) {
    return null;
  }

  const handleChangeClick = async (organizationId) => {
    try {
      const request = {
        body: {
          organizationId: organizationId,
        },
      };

      const response = await updateRecruiterOrganization(request);

      if (response.success) {
        logoutFunction(logout);
      } else {
        errorDispatch({
          type: "set_error",
          payload: response.data.data || response.data.message,
        });
      }
    } catch (err) {
      console.log(err);
      errorDispatch({
        type: "set_error",
        payload: err.message,
      });
    }
  };

  if (user.role === "super") {
    return (
      <SuperadminWrapper>
        <SuperAdminOrganizationBadge>
          <SuperAdminOrganizationBadgeHeader>
            <Typography tag="p" fontWeight="900" nomargin color="white">
              Support mode active
            </Typography>
            <Icon width="30" color="white" icon="info" />
          </SuperAdminOrganizationBadgeHeader>
          <SuperAdminOrganizationBadgeContent>
            <Typography tag="p" nomargin color="white">
              Organization name:
            </Typography>
            <Typography tag="p" larger nomargin bold color="white">
              {organization.name?.length > 20
                ? `${organization.name.slice(0, 20)}....`
                : organization.name}
            </Typography>
            <InputFieldWithLink
              byline="Career page"
              bylineColor="white"
              value={url || ""}
              href={url}
              noBorder
              notEditable
              readOnly
              mt="0"
            />
            <InputFieldWithLink
              byline="Stripe customer"
              bylineColor="white"
              value={organization.customerId || ""}
              href={stripeCustomerUrl}
              noBorder
              notEditable
              readOnly
              mt="0"
            />
            <InputFieldWithLink
              byline="Stripe subscription"
              bylineColor="white"
              value={organization.subscriptionId || ""}
              href={stripeSubscriptionUrl}
              noBorder
              notEditable
              readOnly
              mt="0"
            />
            <Button
              red
              uppercase
              mt="30"
              fullWidth
              justifyContent="center"
              onClick={() => handleChangeClick(user.superOrganizationId)}
            >
              <Icon icon="arrrow_left_from_bracket" mr="20" white scale="2" />
              Exit support mode
            </Button>
          </SuperAdminOrganizationBadgeContent>
        </SuperAdminOrganizationBadge>
      </SuperadminWrapper>
    );
  } else {
    return null;
  }
};

export default Superadmin;
